import WORKOUT_SECTIONS_KEY from './key'

const WORKOUT_SECTIONS_STATE = {
  [WORKOUT_SECTIONS_KEY.ALL]: {
    data: [],
    status: null
  },
  [WORKOUT_SECTIONS_KEY.CURRENT]: null,
  [WORKOUT_SECTIONS_KEY.DATA]: {}
}

export default WORKOUT_SECTIONS_STATE
